import React, {Fragment} from "react";

import './FormInputCheckbox.scss' ;
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents/SmartErrorDiv";
import FormRating from "root/ReactHookForm/ui/FormRating";

export const labelPositions = {
    TOP: 1,
    RIGHT: 2,
}

const FormInputRating = ( { control, formErrors, readOnly, sectionName, name, style, className } ) =>
{
    const classText = className === undefined ? "form-field" : '' ;
    const styleObj = style === undefined ? {} : style ;

    return (
        <div className={classText} style={styleObj}>
            <FormRating readOnly={readOnly} control={control} name={sectionName + '.' + name}/>
            <SmartErrorDiv sectionName={sectionName} name={name} formErrors={formErrors} />
        </div>
    )
}

export { FormInputRating };